module.exports = __webpack_public_path__ + "img/blue_037.50fcdb07.png";